const SearchForm = ({ searchTerm, setSearchTerm, handleSearch, Cargando }) => (
  <div className="row mt-3">
    <div className="col-md-12">
      <div className="card">
        <div className="card-body">
          <form className="form-inline my-2 my-lg-0" onSubmit={handleSearch}>
            <div className="row">
              <div className='col-md-8'>
                <input 
                  className="form-control mr-sm-2" 
                  type="search" 
                  placeholder="Buscar documento" 
                  aria-label="Buscar" 
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />        
              </div> 
              <div className='col-md-4'>
                {Cargando && <button className="btn btn-primary my-2 my-sm-0" type="submit" disabled>Buscar</button>}
                {!Cargando && <button className="btn btn-primary my-2 my-sm-0" type="submit">Buscar</button>}        
              </div> 
            </div>            
          </form>
        </div>
      </div>
    </div>
  </div>
);

export default SearchForm;